import { Pipe, PipeTransform } from '@angular/core';

import { UISeparatedPipe } from '@app/ui/pipes/separated/separated.pipe';

@Pipe({
	name: 'pluralise',
})
export class UIPluralisePipe implements PipeTransform {
	constructor(private separated_pipe: UISeparatedPipe) {}

	transform(value: number, singular: string, plural: string, include_value: boolean = true): string {
		const plural_word = plural.startsWith('+') ? singular + plural.slice(1) : plural;
		return (
			(include_value ? this.separated_pipe.transform(value) + ' ' : '') + (value === 1 ? singular : plural_word)
		);
	}
}
